function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "f84b3174-8b9f-4dd8-bfe3-ee12ab3891b1",
  x1: 790.73,
  y1: 596.5,
  x2: 943.73,
  y2: 596.5,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "user flow");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M676.41,234.35c-64.72-2.25-126.36-23.14-185.22-46S374,140.16,310.85,128.05c-40.63-7.79-87.09-8.89-119.83,12.89-31.5,21-41.68,57.15-47.16,90.73-4.11,25.26-6.53,51.84,4.75,75.49,7.83,16.42,21.74,30.22,31.36,45.95,33.46,54.72,9.81,122.2-26.46,175.63-17,25.07-36.74,49-49.87,75.66s-19.2,57.25-7.72,84.47c11.39,27,38.52,47.24,67.91,61.49,59.68,28.95,130,37.23,198.61,41.92,151.82,10.39,304.46,5.89,456.68,1.39,56.34-1.67,112.93-3.36,168.35-12.07,30.77-4.84,62.55-12.51,84.89-31.05,28.36-23.53,35.39-63.38,16.39-92.88-31.88-49.49-120-61.78-142.31-114.9-12.27-29.23.33-61.79,18.15-88.91,38.24-58.16,102.33-109.19,105.71-175.67,2.32-45.67-28.49-91.39-76.13-113-49.94-22.64-119.18-19.8-156,17.69C800.21,221.48,733.55,236.33,676.41,234.35Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0",
  opacity: 0.1
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "abffebd3-2ac6-4c6b-a0d4-e62621854ed7",
  "data-name": "flowers",
  opacity: 0.6
}, React.createElement("path", {
  d: "M332.74,347.09s-27.49-48.69-68.88-62.72A84.75,84.75,0,0,1,221,252.27a142.27,142.27,0,0,1-12.66-22.77",
  transform: "translate(-74.4 -101.38)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("path", {
  d: "M182.26,220.5c4.71,4.58,26.68,9.31,26.68,9.31s-5.39-21.81-10.11-26.39a11.9,11.9,0,1,0-16.57,17.08Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M194.68,260c6.45,1.28,27.46-6.69,27.46-6.69s-16.38-15.38-22.83-16.66A11.9,11.9,0,1,0,194.68,260Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M239.93,302.69c6.21-2.15,20.33-19.63,20.33-19.63s-21.91-5-28.12-2.86a11.9,11.9,0,0,0,7.79,22.49Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M281.44,327.31c6.49-1.07,23.36-15.92,23.36-15.92s-20.74-8.64-27.23-7.57a11.9,11.9,0,0,0,3.87,23.49Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M240.46,236.24c0,6.58-11.89,25.64-11.89,25.64s-11.91-19-11.91-25.63a11.9,11.9,0,0,1,23.8,0Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M288.65,265.64c-2,6.28-19,20.91-19,20.91s-5.66-21.75-3.7-28a11.9,11.9,0,0,1,22.72,7.11Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M331.56,300.64c-.87,6.52-15.21,23.83-15.21,23.83s-9.26-20.48-8.38-27a11.9,11.9,0,0,1,23.59,3.17Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M182.26,220.5c4.71,4.58,26.68,9.31,26.68,9.31s-5.39-21.81-10.11-26.39a11.9,11.9,0,1,0-16.57,17.08Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.25
}), React.createElement("path", {
  d: "M194.68,260c6.45,1.28,27.46-6.69,27.46-6.69s-16.38-15.38-22.83-16.66A11.9,11.9,0,1,0,194.68,260Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.25
}), React.createElement("path", {
  d: "M239.93,302.69c6.21-2.15,20.33-19.63,20.33-19.63s-21.91-5-28.12-2.86a11.9,11.9,0,0,0,7.79,22.49Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.25
}), React.createElement("path", {
  d: "M281.44,327.31c6.49-1.07,23.36-15.92,23.36-15.92s-20.74-8.64-27.23-7.57a11.9,11.9,0,0,0,3.87,23.49Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.25
}), React.createElement("path", {
  d: "M240.46,236.24c0,6.58-11.89,25.64-11.89,25.64s-11.91-19-11.91-25.63a11.9,11.9,0,0,1,23.8,0Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.25
}), React.createElement("path", {
  d: "M288.65,265.64c-2,6.28-19,20.91-19,20.91s-5.66-21.75-3.7-28a11.9,11.9,0,0,1,22.72,7.11Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.25
}), React.createElement("path", {
  d: "M331.56,300.64c-.87,6.52-15.21,23.83-15.21,23.83s-9.26-20.48-8.38-27a11.9,11.9,0,0,1,23.59,3.17Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.25
}), React.createElement("path", {
  d: "M331.16,346.13s-5.4-55.66-37.56-85.26a84.76,84.76,0,0,1-26.22-46.73A142.25,142.25,0,0,1,265,188.19",
  transform: "translate(-74.4 -101.38)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("path", {
  d: "M244.88,169.41c2.46,6.1,20.62,19.33,20.62,19.33s3.92-22.13,1.46-28.23a11.9,11.9,0,1,0-22.08,8.9Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M240.25,210.54c5.37,3.78,27.81,5,27.81,5s-8.74-20.7-14.12-24.48a11.9,11.9,0,1,0-13.69,19.47Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M264.3,267.93c6.55.55,26.55-9.72,26.55-9.72s-18-13.45-24.55-14a11.9,11.9,0,0,0-2,23.72Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M292.28,307.25c6.37,1.65,27.81-5.09,27.81-5.09s-15.47-16.3-21.83-18a11.9,11.9,0,1,0-6,23Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M291.72,207.39c-2.66,6-21.26,18.62-21.26,18.62s-3.17-22.24-.51-28.25a11.9,11.9,0,1,1,21.77,9.63Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M323.86,253.8c-4.34,4.93-25.86,11.4-25.86,11.4s3.63-22.17,8-27.11a11.9,11.9,0,0,1,17.89,15.71Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}), React.createElement("path", {
  d: "M348.9,303.18c-3.44,5.6-23.55,15.62-23.55,15.62s-.17-22.47,3.27-28.08a11.9,11.9,0,1,1,20.28,12.46Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M221.76,267.24s147,6,167,0c0,0-11,246-7,254,0,0-163,9-175,0S221.76,267.24,221.76,267.24Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M243.76,313.24s68,108,91,118",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M334.76,313.24s-65,85-75,114",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M243.76,472.24",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M328.76,472.24h-79c-6,0-6,28-6,28h85Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M497.76,267.24s141-7,167,0c0,0-11,246-7,254,0,0-180.16,14.09-175,0C493.76,491.24,497.76,267.24,497.76,267.24Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M552.71,286s31.38,49.85,42,54.46",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M594.71,286s-30,39.23-34.62,52.62",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M630.52,372.24h-106c-8,0-8,28-8,28H630.52Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M616.05,461.24h-79c-6,0-6,28-6,28h85Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M630.52,413.24c8.05,0-96.62,9-106,0-4.94-4.73-8,28-8,28H630.52Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref17 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "488.87 373.36 494.87 379.36 505.87 364.36",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M766.76,269.24s140,17,167,0c0,0-11,246-7,254,0,0-185.8,10.41-175,0C778.76,497.24,766.76,269.24,766.76,269.24Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M786.21,312.74s20.17,32,27,35",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M813.21,312.74S793.93,338,791,346.56",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M901.52,378.74h-106c-8,0-8,14.82-8,14.82H901.52Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M843.73,422.74h55.21c8,0,8,14.82,8,14.82h.24",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M901.52,400.43c8.05,0-96.62,4.76-106,0-4.94-2.5-8,14.81-8,14.81H901.52Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M767.6,288s155.2,11.47,165.18,3.85",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M913.25,280.91c2.12-.45,4.3.19,6.45.52s4.59.29,6.15-1.21",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M912.18,284.85a57.24,57.24,0,0,0,13.58.75",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M912.16,290.44a103.08,103.08,0,0,1,11.61-1.3",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M776.33,283a13.19,13.19,0,0,0,6,1.21,5.59,5.59,0,0,0,3.74-.81c1.31-1.06,1.42-3,1.42-4.69a3.52,3.52,0,0,0-.22-1.51,3,3,0,0,0-1.07-1.12c-2.47-1.72-7.06-2.42-9.95-1.25C772.29,276.43,772.93,281.15,776.33,283Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M820.58,306.48c-.58,7.4,1.19,14.75,2.38,22.08a144.3,144.3,0,0,1,1.78,28q-23.67,1.44-47.4.69c1.47.05,1.1-33.44,1.24-36.52.18-3.94-.66-10.72,3.91-12.2,4.8-1.57,11.56-.6,16.6-.84Q809.83,307.19,820.58,306.48Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fff",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M411.76,382.24s39-2,46,0",
  transform: "translate(-74.4 -101.38)",
  fill: "none",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M457.76,361.24s17,17,17,21-22,18-22,18",
  transform: "translate(-74.4 -101.38)",
  fill: "none",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M681.76,382.24s39-2,46,0",
  transform: "translate(-74.4 -101.38)",
  fill: "none",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M727.76,361.24s17,17,17,21-22,18-22,18",
  transform: "translate(-74.4 -101.38)",
  fill: "none",
  stroke: "#33313f",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref34 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 377.32,
  cy: 21.63,
  r: 21.63,
  fill: "#4527a0",
  opacity: 0.1
});

var _ref35 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 706.43,
  cy: 51.49,
  r: 21.63,
  fill: "#4527a0",
  opacity: 0.1
});

var _ref36 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 937.58,
  cy: 371.93,
  r: 21.63,
  fill: "#4527a0",
  opacity: 0.1
});

var _ref37 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 1014.95,
  cy: 275.5,
  r: 36.25,
  fill: "#4527a0",
  opacity: 0.1
});

var _ref38 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 966.96,
  cy: 451.42,
  r: 36.25,
  fill: "#4527a0",
  opacity: 0.1
});

var _ref39 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 36.25,
  cy: 338.07,
  r: 36.25,
  fill: "#4527a0",
  opacity: 0.1
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M942.49,488.14a18.09,18.09,0,0,0-.45-3.59c-.91-3.37-2.93-7.46-6.28-8.48a52.83,52.83,0,0,1-9.93-4.2c-.61-10.72,1.86-21.69-.83-32.08-1-3.8-2.64-7.44-3.09-11.34-.55-4.83.78-10-1.15-14.46-1.52-3.51-4.86-6-8.46-7.3s-7.46-1.64-11.27-2c-4.8-.4-20.34-2.24-25.75,2.06h0a5.35,5.35,0,0,0-1,1l0,0a3.51,3.51,0,0,0-.33.52.35.35,0,0,1,0,.08,6.32,6.32,0,0,0-.27.65h0a3.76,3.76,0,0,0-.16.74,1.9,1.9,0,0,0,0,.25,4.58,4.58,0,0,0,0,.53v.26c0,.19,0,.37,0,.55s0,.15,0,.22c.07.89.21,1.8.21,2.69a5.85,5.85,0,0,1-.12,1.32,9.28,9.28,0,0,1-1.66,3.23h0l-.18.26-.33.48-.26.41-.22.36c-.1.17-.18.34-.27.52l-.15.28a6.11,6.11,0,0,0-.3.85,5.54,5.54,0,0,0,0,2.65,10.15,10.15,0,0,0,1.36,3.16c.25.41.53.81.81,1.21s.46.63.7.94a20,20,0,0,0-.22,2.81,20.65,20.65,0,0,0,7.91,16.25,62,62,0,0,1-.13,12.69c-.1.89-.2,1.77-.32,2.65s-.22,1.47-.33,2.2a10.2,10.2,0,0,1-4.38-.34,20.41,20.41,0,0,0-2-.77c-2.92-.72-5.89,2.18-8.76,1.3,0,.13-.09.26-.13.4a4,4,0,0,0-2-.59c-1.7-.08-3.1-1.32-4.34-2.49l-3.8-3.59a3.85,3.85,0,0,1-.66-.74,4.93,4.93,0,0,1-.46-1.23,14.21,14.21,0,0,0-3.69-5.29,2.5,2.5,0,0,0-1.1-.79,1.35,1.35,0,0,0-.49,0c-.11-.14-.21-.28-.33-.41-.27-.29-.55-.57-.84-.83-1.81-1.68-2-3.12-3.58-5a47.17,47.17,0,0,1-3.73-5.65c-.14-1-.32-2.12-.54-3.22a41.08,41.08,0,0,0-2.18-7.29l1.37-1.5,0-1.49,2.44-2.85-.17-.15,3-2.82-3-.11L839.25,423l-.11-.1-2.5,2.5-1.75.2-.23.24c-1.45-2.16-3-3.34-4.38-3.06-2.33.48-3.49,5-3.12,10.91l-6.93,7.25-.78.82-3.58,4.59,2.81,2.7,4.31-4,.69-.75,4.29-4.65c0,.15.07.3.1.45a12.08,12.08,0,0,0-.22,2.16c0,.85.79,1.46,1.19,2.22a6.08,6.08,0,0,1,1,3.41c0,.42-.18.83-.19,1.26a4.77,4.77,0,0,0,.93,2.59q2.51,4.2,5,8.4c.34.59.7,1.18,1,1.76a.41.41,0,0,1,0,.09,4.25,4.25,0,0,0,1.34,1.53,18.38,18.38,0,0,0,1.65,6.08c.18.37.37.74.57,1.1a35.24,35.24,0,0,0,4.71,6.12l2.39,2.67c2.34,2.63,4.69,5.25,7.24,7.68a9.67,9.67,0,0,0,3.25,2.26,3.63,3.63,0,0,0,3.63-.52c0,1.24,0,2.48,0,3.71a2.65,2.65,0,0,1,1.75,1.14,2.55,2.55,0,0,1-.17,2.16c-2.09,5.39-4.21,10.82-7.4,15.66a33,33,0,0,1,6.2,4.72,27.41,27.41,0,0,1,3.24,4.38c.08.73.15,1.47.2,2.2.74,11.92-3.87,23.75-8,35.11-1.18,3.21-2.49,6.59-2.38,9.93a20.63,20.63,0,0,0-2.25,1.62c.82,2.13.5,4,.42,6.33a11.25,11.25,0,0,1-.84,4c-.39.89-1,1.72-1.43,2.57-2.59,4.57-3.17,10-3.69,15.21-.31,3.16.92,7-.52,9.82-2.46,4.85-4.65,10-5.05,15.38a16.06,16.06,0,0,1-.45,3.6c-.31,1-.87,1.85-1.15,2.83a12.06,12.06,0,0,0-.19,4,38.23,38.23,0,0,1-2.11,14.11c-1.25,3.58-2.62,7.4-1.64,11.07a15.53,15.53,0,0,0-4.23,9.28,14.66,14.66,0,0,1-.33,2.65,13.2,13.2,0,0,1-1.19,2.56,22.4,22.4,0,0,0-2.73,12c-3,4.06-4.49,9.09-5.38,14.08s-1.29,10.07-2.43,15c-1.51,6.53-4.26,13.12-4.81,19.79-3.24,2.08-4.63,6.09-5.26,9.88s-.72,7.76-2.3,11.27c-.82,1.82-2,3.45-2.78,5.3a23.86,23.86,0,0,0-1.21,4.57c-.48,2.45-.9,5.16-.3,7.5a11.29,11.29,0,0,1-2.93,2.24c.15-.62.29-1.25.39-1.88-2.58,2.35-7.25,1.53-9.32,4.34a4.24,4.24,0,0,0,1,5.79,8.16,8.16,0,0,0,2.08.89c4.95,1.59,10.14,3.21,15.27,2.36a4.63,4.63,0,0,0,1.73-.56,5.37,5.37,0,0,0,1.61-1.86l2.31-3.66a47.55,47.55,0,0,0,5.61,1.32q.28,2.39.39,4.8c1,.2,2.34.25,2.81-.67a2.45,2.45,0,0,0,.18-1.11c0-.72.09-1.66.16-2.62l.2,0a19,19,0,0,0,8.85-1.8c-1.08-8.85,2.45-17.51,5.52-25.89,3.23-8.82,6-17.81,8.78-26.79,2-6.31,4.22-12.44,6.17-18.76q3.72-12,7.43-24c1.09-3.52,2.17-7,3.42-10.5a164.43,164.43,0,0,1,9.26-20.64c1-1.88,2-3.75,2.83-5.72,1-2.39,1.71-4.89,2.5-7.35a115,115,0,0,1,6.29-14.79l.18-.37c.81,3.31,1.63,6.68,2.16,10a37.72,37.72,0,0,1,.17,12.36c-.48,2.79-1.39,5.55-1.27,8.37.15,3.92,2.23,7.46,3.26,11.24a43.48,43.48,0,0,1,1.13,8.6c.27,4.49,2.72,9.54,1,13.71-5.34,13.21-2.75,28.13-5.81,42-1.56,7.12-6.37,13.82-6,21.1q.4,7.75,1.36,15.46a14.42,14.42,0,0,0,1.09,4.56,20.52,20.52,0,0,0,1.37,2.23c-.43.18-.81.63-1.12,1.58a6,6,0,0,0,2.22,7,9.66,9.66,0,0,0,2.88,1,15.67,15.67,0,0,0,4.18.58,8.24,8.24,0,0,0,1.31-.17,46.24,46.24,0,0,0,4.74,1.7q0,.62.12,1.23a1.47,1.47,0,0,0,.53,1.13,1.44,1.44,0,0,0,.8.15l5.43,0c0-.45,0-.91,0-1.36a4.43,4.43,0,0,0,3.45-1.13,5.1,5.1,0,0,0,1-2.07q2.22-7.54,4.42-15.07a45.7,45.7,0,0,0,1.55-6.49,44.34,44.34,0,0,0,.59-10.72c-1.92-18.43,2.32-36.92.94-55.4a132.16,132.16,0,0,1,1.7-33.23c.45-2.48,1-5,1.2-7.47.43-4.66-.1-9.37.22-14,.12-1.62.34-3.23.54-4.84A232.42,232.42,0,0,0,923.37,607a92.15,92.15,0,0,0-.61-10,5.89,5.89,0,0,0,2.72-1.6c.9-1.17.67-2.79.66-4.27,0-3.54,1.49-6.89,2.68-10.23a123.37,123.37,0,0,0,3.79-14,49.23,49.23,0,0,0,1.68-11.75c0-.4,0-.8-.06-1.21a3,3,0,0,0,.91-1,5.62,5.62,0,0,0,.48-1.85c.37-2.56.73-5.11,1.1-7.67q.39-2.75.79-5.5,1.59-11.08,3.17-22.18c.28-1.93.55-3.85.83-5.78l.82-5.73c.1-.68.19-1.36.27-2.05C945.08,498.23,942.74,492.78,942.49,488.14ZM916,571.22c-1.19-2.79-2.29-5.66-2-8.69l-.1,0a4.53,4.53,0,0,0-.14-2.82c-.31-.74-.84-1.36-1.17-2.08a7.63,7.63,0,0,1-.54-2.81,76.77,76.77,0,0,1,1.42-18.13c.13-.71.27-1.41.41-2.12a5.36,5.36,0,0,0,1.13-.88,8.19,8.19,0,0,0,1.29-2q1.69-3.4,3.12-6.93c.31-.77.76-1.64,1.53-1.83-.16,5.85.44,11.82-2,17.1a10.64,10.64,0,0,0-1,2.7c-.22,1.48.4,3,.18,4.48-.11.76-.44,1.48-.58,2.23a2.2,2.2,0,0,0,.59,2.12,1.55,1.55,0,0,0,.42.23c-.06.4-.11.81-.14,1.2-.09.82-.12,1.59-.17,2.07a64.42,64.42,0,0,0-.28,7.35c0,2.65.11,5.31.06,8a5.3,5.3,0,0,1-.38,2.27,3.89,3.89,0,0,1-.76,1C916.61,572.79,916.29,572,916,571.22Z",
  transform: "translate(-74.4 -101.38)",
  fill: "url(#f84b3174-8b9f-4dd8-bfe3-ee12ab3891b1)"
});

var _ref41 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "766.01 324.14 769.37 321.01 766.37 320.9 764.8 323.3 766.01 324.14",
  fill: "#33313f"
});

var _ref42 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "741.84 346.06 745.4 341.49 746.19 340.67 757.09 329.26 760.8 325.37 762.54 325.17 765.04 322.68 766.51 323.97 764.08 326.81 764.13 328.3 760.33 332.42 749.63 344.03 748.94 344.77 744.64 348.75 741.84 346.06",
  fill: "#65617d"
});

var _ref43 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "746.19 340.67 757.09 329.26 760.33 332.42 749.63 344.03 746.19 340.67",
  fill: "#33313f"
});

var _ref44 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 833.81,
  cy: 439.58,
  rx: 5.64,
  ry: 15.97,
  transform: "translate(-145.66 74.91) rotate(-11.58)",
  fill: "#fbbebe"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M883.62,776.62a6,6,0,0,0,2.21,6.94,9.83,9.83,0,0,0,2.88,1,15.53,15.53,0,0,0,4.16.58c1.74-.09,3.4-.76,5.12-1a.84.84,0,0,1,.59.09.87.87,0,0,1,.23.69,26.43,26.43,0,0,0,.22,2.95,1.13,1.13,0,0,0,1.32,1.27l5.41,0A52,52,0,0,0,904.19,775a3.07,3.07,0,0,0-.4-1,3.19,3.19,0,0,0-1.72-1,9.72,9.72,0,0,0-4.2-.73c-1.74.22-3.21,1.36-4.7,2.3s-3.52,1.77-5.33,1.28S884.54,773.84,883.62,776.62Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#3f3d56"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M804,772.23a14.92,14.92,0,0,1-5.46,3.71l-.93.45a.5.5,0,0,0-.3.25.54.54,0,0,0,.09.45,6.49,6.49,0,0,0,7.34,2.67,3.93,3.93,0,0,0,1.62-.84,5.36,5.36,0,0,0,1.24-3.23,6.75,6.75,0,0,0-.15-3.68C806.09,768.87,805.58,770.29,804,772.23Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fbbebe"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M824.82,784.55a2.32,2.32,0,0,1-.18,1.11c-.46.92-1.78.86-2.8.67a67.25,67.25,0,0,0-1.22-10.11c-1.94-.09-3.35,1.76-4.38,3.4l-2.68,4.26a5.44,5.44,0,0,1-1.61,1.85,4.65,4.65,0,0,1-1.72.56c-5.12.84-10.29-.77-15.23-2.36a8.27,8.27,0,0,1-2.07-.88,4.22,4.22,0,0,1-1-5.78c2.06-2.8,6.72-2,9.29-4.32a22.67,22.67,0,0,1-1.32,4.77c3.46-.52,5.77-3.68,8.56-5.79a5.09,5.09,0,0,1,2.44-1.17,5.4,5.4,0,0,1,2,.22,23.39,23.39,0,0,1,8.8,4.33c1.05.83,2.69,2,3.15,3.28C825.34,780.12,824.81,782.92,824.82,784.55Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#3f3d56"
});

var _ref48 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 819.21,
  cy: 332.56,
  r: 20.66,
  fill: "#fbbebe"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M934.31,555.93a48.83,48.83,0,0,1-1.68,11.71,120.22,120.22,0,0,1-3.77,14c-1.19,3.33-2.69,6.67-2.68,10.2,0,1.47.24,3.09-.65,4.26a6.34,6.34,0,0,1-2.93,1.67,3.64,3.64,0,0,0-2.45,2.18,15.3,15.3,0,0,1-2.09-4.57q-2.68-8.24-5-16.57a2.15,2.15,0,0,1,.13-2,2.38,2.38,0,0,1,.88-.49,9,9,0,0,0,2.76-1.79,4.08,4.08,0,0,0,.93-1.18,5.3,5.3,0,0,0,.38-2.27c0-2.64,0-5.29-.06-7.93a66.34,66.34,0,0,1,.27-7.33c0-.49.09-1.25.17-2.07.15-1.58.45-3.39,1.31-4,1.26-.86,5.06.29,6.51.48,2.48.35,4.95.75,7.41,1.22A20.34,20.34,0,0,1,934.31,555.93Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#3f3d56"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M850.88,457.08c-.8,1.6-2.72,2.36-4.2,3.38l-5.07,3.48a3.42,3.42,0,0,1-2.5.86,3.3,3.3,0,0,1-1.87-1.75l-.06-.09-1-1.75-5-8.38a4.86,4.86,0,0,1-.93-2.59c0-.42.15-.83.2-1.25a6.19,6.19,0,0,0-1-3.4c-.4-.76-1.21-1.37-1.18-2.21a7.88,7.88,0,0,1,.56-3.24,6.6,6.6,0,0,1,2.18-2.34c.47-.34,1-.66,1.45-1a2.89,2.89,0,0,1,.88-.39c.82-.17,1.64.51,2.48.54,3.62,2.42,5,7,7.85,10.31,1.6,1.87,1.76,3.31,3.57,5a9.29,9.29,0,0,1,.83.83,5.34,5.34,0,0,1,.91,1.3C849.3,455.24,851.3,456.26,850.88,457.08Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#3f3d56"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M886.34,454.66c1.49,3.15,2.65,6.61,2.22,10.07a6.32,6.32,0,0,1-.86,2.65c-1.44,2.21-4.46,2.6-7.1,2.74a4.19,4.19,0,0,0-3.07,1,2.78,2.78,0,0,0,.19,3.42,7.48,7.48,0,0,0,3.06,2c4.16,1.84,8.64,3.35,13.17,2.92,2.1-.2,4.14-.8,6.23-1.11A62.67,62.67,0,0,1,907,478c2.72-.1,5.43-.37,8.14-.64l7.17-.71a1.58,1.58,0,0,0,1.07-.39c.54-.62-.15-1.53-.8-2-3.82-2.83-8.67-4.76-10.83-9-1-2-1.32-4.37-2.06-6.54s-1.92-4.1-2.37-6.31a41.58,41.58,0,0,1-.33-5.81,7.74,7.74,0,0,0-2-5.32c-1.42-1.33-3.49-1.67-5.44-1.76-4.78-.2-9.86.94-13.26,4.31-.91.91-1.68,1.95-2.63,2.82s-2.21,1.06-1.59,2.14,1.83,1.74,2.49,2.7A22.38,22.38,0,0,1,886.34,454.66Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#fbbebe"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M927.08,483.7A114.62,114.62,0,0,1,921,506.23a83.28,83.28,0,0,0-3.6,10.11c-.78,3.1-.62,6.42-1.34,9.53-.88,3.86-1.76,7.75-2.47,11.65a76.31,76.31,0,0,0-1.42,18.08,7.62,7.62,0,0,0,.54,2.8c.33.72.87,1.34,1.17,2.07a4.93,4.93,0,0,1-.27,4,11.71,11.71,0,0,1-2.06,3.13c-9.33,2.78-19.29,1.86-29,2.45-9,.55-18,2.39-26.82.85-1-4,.66-8.18,2.1-12.08,4.14-11.33,8.74-23.13,8-35a36.12,36.12,0,0,0-.48-4.12c-1.44-8.41.13-17.12,2.66-25.28,1.58-5.07,1.51-10.49,1.14-15.78a28.71,28.71,0,0,1-.07-5.16,9.22,9.22,0,0,1,1.88-4.83l.15-.21c.11-.17.44-.07.74,0h0a.65.65,0,0,0,.5,0,.23.23,0,0,1,.11-.07.28.28,0,0,1,.29,0c.23.15.35.62.85.71a20,20,0,0,0,2.23.22,11.93,11.93,0,0,1,2.66.38l.12,0a7.91,7.91,0,0,0,3.88-.33,10.38,10.38,0,0,0,2.38-.92,16.58,16.58,0,0,1,1.88-.63c.92-.56.72-3.14.91-4.19a11.51,11.51,0,0,1,.74-3.1,5.26,5.26,0,0,1,4.28-2.49,21.77,21.77,0,0,1,5.14.46c3.72.53,7.54.43,11.21,1.29,1.84.43,3.84,1.09,5.54.25.45.1.52.51.52,1a5.47,5.47,0,0,1-.28,1.37c-.63,2.76,1.54,5.29,3.53,7.3a11.54,11.54,0,0,0,3,2.35c1,.46,2,.65,3,1.15a5.3,5.3,0,0,1,2,1.83,7.42,7.42,0,0,1,1.14,2.91A17.33,17.33,0,0,1,927.08,483.7Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#3f3d56"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M927.08,483.7A114.62,114.62,0,0,1,921,506.23a83.28,83.28,0,0,0-3.6,10.11c-.78,3.1-.62,6.42-1.34,9.53-.88,3.86-1.76,7.75-2.47,11.65-.21.12-.42.22-.64.32a15.5,15.5,0,0,1-3.92,1.27,24.39,24.39,0,0,1-7.33-.24L887.4,537c-5.7-.76-11.77-1.69-16-5.55-2.34-2.12-3.89-4.92-5.57-7.63a36.12,36.12,0,0,0-.48-4.12c-1.44-8.41.13-17.12,2.66-25.28,1.58-5.07,1.51-10.49,1.14-15.78a28.71,28.71,0,0,1-.07-5.16,9.22,9.22,0,0,1,1.88-4.83,7.61,7.61,0,0,1,.89-.21h0a4.22,4.22,0,0,1,.61-.07l.29,0a4.36,4.36,0,0,1,1,.12c.67.17,1.29.53,1.95.77l.12,0a7.94,7.94,0,0,0,2.66.38c1.32,0,2.68-.22,4-.3a7.36,7.36,0,0,1,4.74.84,27.43,27.43,0,0,1,2.64,2.42,11.87,11.87,0,0,0,3.34,1.81,35.32,35.32,0,0,0,26.61-.57,5.32,5.32,0,0,1,2.67-.67,5.13,5.13,0,0,1,1.93.81c.59.35,1.19.69,1.79,1a7.42,7.42,0,0,1,1.14,2.91A17.33,17.33,0,0,1,927.08,483.7Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.1
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M935.78,477.08a52.55,52.55,0,0,1-11.39-5,5.06,5.06,0,0,0-1.93-.82,5.23,5.23,0,0,0-2.67.68,35.37,35.37,0,0,1-26.61.56,11.63,11.63,0,0,1-3.34-1.81,28.56,28.56,0,0,0-2.63-2.42c-3.29-2.13-7.84.38-11.53-1a20.24,20.24,0,0,0-1.95-.77c-2.91-.72-5.87,2.17-8.74,1.3a47.43,47.43,0,0,0-2.34,8.92,97.08,97.08,0,0,0-.65,10.52c-.06,2.1-.11,4.21,0,6.32a2.65,2.65,0,0,1,1.75,1.14,2.54,2.54,0,0,1-.17,2.14c-2.09,5.38-4.2,10.8-7.38,15.62a32.82,32.82,0,0,1,6.18,4.72c3.51,3.7,5.22,8.88,9,12.3,4.26,3.86,10.34,4.79,16,5.56L901.66,537a24.39,24.39,0,0,0,7.33.24,15.5,15.5,0,0,0,3.92-1.27,7,7,0,0,0,2.18-1.44,8.23,8.23,0,0,0,1.29-2c1.12-2.26,2.16-4.57,3.1-6.91.34-.83.84-1.81,1.74-1.87,5.29-4.78,10.3-9.68,15.59-14.46a34.53,34.53,0,0,0,5.69-6c2.64-3.89.24-9.41,0-14.1a17.27,17.27,0,0,0-.44-3.58C941.13,482.18,939.11,478.1,935.78,477.08Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M850.88,457.08c-.8,1.6-2.72,2.36-4.2,3.38l-5.07,3.48a3.42,3.42,0,0,1-2.5.86,3.3,3.3,0,0,1-1.87-1.75c0-.24,0-.48,0-.72a6.65,6.65,0,0,1,.32-2.39,7.54,7.54,0,0,1,2.24-2.88,18.15,18.15,0,0,1,6.57-4,2.2,2.2,0,0,1,1.21-.12,1.52,1.52,0,0,1,.43.19,5.34,5.34,0,0,1,.91,1.3C849.3,455.24,851.3,456.26,850.88,457.08Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.1
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M862.82,467.65c-1.7-.08-3.09-1.32-4.32-2.49l-3.8-3.58a3.6,3.6,0,0,1-.66-.74,5.26,5.26,0,0,1-.45-1.22,14.34,14.34,0,0,0-3.68-5.28,2.59,2.59,0,0,0-1.1-.79,2.19,2.19,0,0,0-1.21.13,18.15,18.15,0,0,0-6.57,4,7.39,7.39,0,0,0-2.24,2.88,6.65,6.65,0,0,0-.32,2.39,18.36,18.36,0,0,0,1.75,7.68c.18.37.36.74.56,1.1a35.93,35.93,0,0,0,4.7,6.1l2.38,2.67c2.34,2.61,4.68,5.23,7.23,7.65a9.5,9.5,0,0,0,3.23,2.26,3.61,3.61,0,0,0,3.72-.61,5.23,5.23,0,0,0,1.06-1.9c1.55-4,3-8.15,3.09-12.46a44.61,44.61,0,0,0-.21-5.17C865.81,468.44,864.53,467.73,862.82,467.65Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M923.42,607.65a231.06,231.06,0,0,1-2.13,30.07c-.2,1.6-.42,3.21-.53,4.83-.33,4.66.2,9.36-.23,14-.24,2.5-.75,5-1.2,7.45a131.91,131.91,0,0,0-1.69,33.14c1.37,18.43-2.85,36.87-.94,55.25a44.59,44.59,0,0,1-.58,10.69,46.49,46.49,0,0,1-1.55,6.47q-2.21,7.52-4.4,15a5.25,5.25,0,0,1-1,2.07,4.71,4.71,0,0,1-3.75,1.12c-5.77-.19-11.19-2.67-16.43-5.11a5.38,5.38,0,0,1-1.65-1c-1.09-1.13-1-2.92-1.48-4.4s-1.79-2.89-2.53-4.43a14.93,14.93,0,0,1-1.09-4.54q-1-7.69-1.36-15.42c-.37-7.26,4.42-13.94,6-21,3.05-13.88.47-28.76,5.8-41.94,1.67-4.15-.76-9.19-1-13.67a42.55,42.55,0,0,0-1.12-8.58c-1-3.77-3.1-7.3-3.25-11.2-.12-2.82.79-5.57,1.27-8.36a38,38,0,0,0-.17-12.32c-.53-3.36-1.35-6.72-2.16-10l-.18.37a113,113,0,0,0-6.27,14.75c-.79,2.45-1.5,4.94-2.5,7.33-.82,2-1.82,3.82-2.81,5.7a162.73,162.73,0,0,0-9.24,20.58c-1.24,3.46-2.32,7-3.41,10.47q-3.69,12-7.4,24c-1.95,6.31-4.2,12.41-6.15,18.71-2.77,9-5.54,17.92-8.76,26.71-3.06,8.36-6.58,17-5.51,25.83a19,19,0,0,1-8.82,1.79,51.78,51.78,0,0,1-15-3.65,11.5,11.5,0,0,1-5.17-3.08c-2.23-2.71-1.67-6.68-1-10.12a23.57,23.57,0,0,1,1.21-4.56c.75-1.85,1.95-3.48,2.77-5.29,1.58-3.5,1.68-7.45,2.3-11.24s2-7.78,5.24-9.85c.54-6.65,3.29-13.23,4.8-19.73,1.14-4.93,1.52-10,2.41-15s2.36-10,5.38-14a22.3,22.3,0,0,1,2.71-12,12.85,12.85,0,0,0,1.19-2.55,14.44,14.44,0,0,0,.33-2.64,15.54,15.54,0,0,1,4.21-9.26c-1-3.66.4-7.46,1.64-11a37.87,37.87,0,0,0,2.1-14.07,12.32,12.32,0,0,1,.2-4c.28-1,.83-1.85,1.14-2.82a14.84,14.84,0,0,0,.45-3.59c.4-5.4,2.58-10.5,5-15.33,1.43-2.82.21-6.65.52-9.8.52-5.22,1.09-10.61,3.67-15.17a25.83,25.83,0,0,0,1.43-2.57,10.92,10.92,0,0,0,.83-4c.09-2.28.41-4.19-.41-6.31,5.35-4.46,12.66-5.7,19.61-5.95s14,.33,20.81-1.16c2-.44,4-1.07,6.11-1.37,4.8-.7,9.65.4,14.38,1.48-.33,3,.77,5.88,1.95,8.67A93.07,93.07,0,0,1,923.42,607.65Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#33313f"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M899.87,609.91l-11.48,25.84c-.53-3.36-1.35-6.72-2.16-10l-.18.37.05-.54,6.26-13.78Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.1
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M934.31,555.93a4.53,4.53,0,0,1-2.28.85,11.4,11.4,0,0,1-3.75-.51L919.33,554a3.78,3.78,0,0,1-.82-.28c.15-1.58.45-3.39,1.31-4,1.26-.86,5.06.29,6.51.48,2.48.35,4.95.75,7.41,1.22A20.34,20.34,0,0,1,934.31,555.93Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.1
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M941.91,496.43c.2.83.47,1.65.62,2.49a19.17,19.17,0,0,1-.2,6.18l-.82,5.72-.82,5.76-3.17,22.13-.79,5.48-1.09,7.65a5.82,5.82,0,0,1-.48,1.84,3.86,3.86,0,0,1-3.14,1.85,11.38,11.38,0,0,1-3.74-.51l-8.95-2.26a2.83,2.83,0,0,1-1.09-.45,2.18,2.18,0,0,1-.59-2.11c.13-.76.46-1.47.58-2.23.22-1.48-.41-3-.18-4.47a10.41,10.41,0,0,1,1-2.7c3-6.63,1.26-14.36,2.28-21.56a32.64,32.64,0,0,1,6.84-15.45,43.5,43.5,0,0,1,7.65-7.51c1.13-.87,2.91-2.67,4.31-3C942,492.9,941.62,495.17,941.91,496.43Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M873.81,410.29c-.66,2.09.37,4.4-.1,6.55-.52,2.36-2.73,4-3.36,6.37-1,3.61,2.06,6.9,4.29,9.9,8.3,11.13,7.21,26.55,4.37,40.15a206.21,206.21,0,0,1-9.45,32c-1.24,3.22-2.63,6.51-5.08,8.93,4.6-1.32,9.48-2.65,14.1-1.37,5.84,1.62,10.88,7.29,16.79,6,3.57-.8,6.06-4,9.27-5.7,6-3.23,13.22-1.2,19.92-.17a7.65,7.65,0,0,0,4.35-.22,7.28,7.28,0,0,0,2.64-2.42,24.67,24.67,0,0,0,5.13-13.3,17,17,0,0,0-4.91-13.13c-1.41-1.34-3.11-2.42-4.2-4a12.26,12.26,0,0,1-1.65-6.06c-.8-11,1.88-22.22-.87-32.86-1-3.79-2.64-7.42-3.08-11.31-.55-4.82.77-10-1.15-14.42-1.52-3.5-4.85-6-8.43-7.27a42.21,42.21,0,0,0-11.24-2C895.67,405.48,876.1,403.14,873.81,410.29Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#33313f"
});

var _ref62 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M879,473.26a206.9,206.9,0,0,1-9.4,31.87c.69-1.37,1.28-2.81,1.83-4.24a206.33,206.33,0,0,0,9.45-32c2.84-13.59,3.93-29-4.37-40.15-2-2.65-4.57-5.53-4.47-8.66a10.48,10.48,0,0,0-1.7,3.15c-1,3.61,2.06,6.9,4.29,9.9C882.94,444.24,881.85,459.66,879,473.26Z",
  transform: "translate(-74.4 -101.38)"
}), React.createElement("path", {
  d: "M873.83,415.82a10,10,0,0,0,1.76-3.37,17.14,17.14,0,0,0-.12-4.46,4.82,4.82,0,0,0-1.66,2.3C873.25,412.06,873.9,414,873.83,415.82Z",
  transform: "translate(-74.4 -101.38)"
}), React.createElement("path", {
  d: "M933.43,505.9a7.34,7.34,0,0,1-2.65,2.43,7.61,7.61,0,0,1-4.34.22c-6.7-1-14-3.07-19.92.17-3.21,1.74-5.71,4.9-9.27,5.69-5.92,1.32-11-4.34-16.8-6-4.13-1.15-8.49-.2-12.67,1a17.49,17.49,0,0,1-3.3,4.79c4.6-1.32,9.48-2.65,14.1-1.37,5.84,1.62,10.88,7.29,16.79,6,3.56-.8,6.06-4,9.27-5.7,6-3.23,13.22-1.2,19.92-.17a7.65,7.65,0,0,0,4.35-.22,7.28,7.28,0,0,0,2.64-2.42,27.49,27.49,0,0,0,4.14-7.92A29.4,29.4,0,0,1,933.43,505.9Z",
  transform: "translate(-74.4 -101.38)"
}));

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M991.29,676.92s5.93,7.76-2.73,19.47S972.74,718,975.63,725.28c0,0,13.08-21.75,23.72-22S1003,690,991.29,676.92Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  d: "M991.29,676.92a9.41,9.41,0,0,1,1.21,2.44c10.39,12.2,15.92,23.58,5.94,23.87-9.3.27-20.45,16.89-23.13,21.09.09.33.2.64.32,1,0,0,13.08-21.75,23.72-22S1003,690,991.29,676.92Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.1
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1002.32,686.81c0,2.73-.31,4.94-.69,4.94s-.68-2.21-.68-4.94.38-1.45.76-1.45S1002.32,684.08,1002.32,686.81Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#ffd037"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1006.1,690.07c-2.4,1.3-4.49,2.09-4.67,1.76s1.62-1.66,4-3,1.46-.35,1.64,0S1008.5,688.76,1006.1,690.07Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#ffd037"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  d: "M960,676.92s-5.93,7.76,2.74,19.47,15.81,21.59,12.92,28.89c0,0-13.08-21.75-23.72-22S948.26,690,960,676.92Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#4527a0"
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  d: "M960,676.92a9.41,9.41,0,0,0-1.21,2.44c-10.39,12.2-15.92,23.58-5.94,23.87,9.3.27,20.46,16.89,23.13,21.09-.09.33-.2.64-.32,1,0,0-13.08-21.75-23.72-22S948.26,690,960,676.92Z",
  transform: "translate(-74.4 -101.38)",
  opacity: 0.1
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  d: "M949,686.81c0,2.73.3,4.94.68,4.94s.68-2.21.68-4.94-.38-1.45-.76-1.45S949,684.08,949,686.81Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#ffd037"
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  d: "M945.16,690.07c2.4,1.3,4.49,2.09,4.67,1.76s-1.62-1.66-4-3-1.45-.35-1.64,0S942.77,688.76,945.16,690.07Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#ffd037"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1007.54,714.83l-.29,2.42-.42,3.42-.17,1.42-.42,3.43-.18,1.42-.41,3.42-4.75,38.9c-.42,3.47-6.1,6.18-12.94,6.18H963.3c-6.84,0-12.51-2.71-12.93-6.18l-4.75-38.9-.42-3.42-.17-1.42-.43-3.43-.17-1.42-.41-3.42-.3-2.42c-.24-2,2.83-3.63,6.7-3.63h50.42C1004.71,711.2,1007.79,712.86,1007.54,714.83Z",
  transform: "translate(-74.4 -101.38)",
  fill: "#444053"
});

var _ref72 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "932.85 615.87 932.43 619.28 870.03 619.28 869.62 615.87 932.85 615.87",
  fill: "#9d9cb5"
});

var _ref73 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "932.26 620.71 931.84 624.13 870.63 624.13 870.21 620.71 932.26 620.71",
  fill: "#9d9cb5"
});

var _ref74 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "931.66 625.56 931.25 628.98 871.22 628.98 870.8 625.56 931.66 625.56",
  fill: "#9d9cb5"
});

var SvgUndrawUserFlowVr6W = function SvgUndrawUserFlowVr6W(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "bcfca5f0-de0d-458d-b0e1-91947ae777e0",
    "data-name": "Layer 1",
    width: 1051.2,
    height: 697.24,
    viewBox: "0 0 1051.2 697.24",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndrawUserFlowVr6W, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_user_flow_vr6w.36aa4cb3.svg";
export { ForwardRef as ReactComponent };